export const AddRentalCloths_REQUEST = "AddRentalCloths_REQUEST";
export const AddRentalCloths_SUCCESS = "AddRentalCloths_SUCCESS";
export const AddRentalCloths_FAIL = "AddRentalCloths_FAIL";

export const GetAllRental_REQUEST = "GetAllRental_REQUEST";
export const GetAllRental_SUCCESS = "GetAllRental_SUCCESS";
export const GetAllRental_FAIL = "GetAllRental_FAIL";

export const UpdateRentalCloths_REQUEST = "UpdateRentalCloths_REQUEST";
export const UpdateRentalCloths_SUCCESS = "UpdateRentalCloths_SUCCESS";
export const UpdateRentalCloths_FAIL = "UpdateRentalCloths_FAIL";

export const GetRentalById_REQUEST = "GetRentalById_REQUEST";
export const GetRentalById_SUCCESS = "GetRentalById_SUCCESS";
export const GetRentalById_FAIL = "GetRentalById_FAIL";

export const ReturnCloth_REQUEST = "ReturnCloth_REQUEST";
export const ReturnCloth_SUCCESS = "ReturnCloth_SUCCESS";
export const ReturnCloth_FAIL = "ReturnCloth_FAIL";

export const RequestCloth_REQUEST = "RequestCloth_REQUEST";
export const RequestCloth_SUCCESS = "RequestCloth_SUCCESS";
export const RequestCloth_FAIL = "RequestCloth_FAIL";

export const PhotoPrivew_REQUEST = "PhotoPrivew_REQUEST";
export const PhotoPrivew_SUCCESS = "PhotoPrivew_SUCCESS";
export const PhotoPrivew_FAIL = "PhotoPrivew_FAIL";